import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';
import { BlockMobile as Block } from '@alfa-bank/site-block/mobile';
import { TextMobile as Text } from '@alfa-bank/site-text-v2/mobile';
import { Link } from '@alfa-bank/site-link';
import { translateISODateToString } from '@alfa-bank/site-invest-common/helpers/date/translate-iso-date-to-string';
import { ImgV2 as Img } from '@alfa-bank/site-img-v2';
import { createPageUrl } from '@alfa-bank/site-invest-mediaportal-common/helpers';
import { FontStyrene } from '@alfa-bank/site-font-styrene';
import { AssetsCarouselMobile as AssetsCarousel } from '@alfa-bank/site-invest-mediaportal-common/components/assets-carousel-mobile';

import type { IArticleProps } from '../../model';
import { sendClickCardAnalytics } from '../../../../helpers/analytics';
import { getFileBanner } from '../../../../helpers/get-file-banner';

import styles from './styles.css';

export const ArticleListMobile: FC<IArticleProps> = ({
    analytics,
    articles,
    baseUrlToArticle,
    baseUrlToAsset,
    dataTestId,
}) => {
    return (
        <div className={cn(styles.external, styles.wrapper)}>
            {articles.map(item => {
                const image = getFileBanner(item);

                return (
                    <Block
                        key={item.path}
                        className={cn(styles.external, styles.block)}
                        notPadded
                        styler={{ borderRadius: 24, padding: 16 }}
                    >
                        <Link
                            className={cn(styles.external, styles.link)}
                            dataTestId={dataTestId}
                            href={createPageUrl(baseUrlToArticle, item.path)}
                            noUnderline
                            onClick={() => sendClickCardAnalytics(item, analytics)}
                        >
                            <Text
                                kind="secondary"
                                styler={{ margin: 0 }}
                                view="action-primary-small"
                            >
                                {item.category.description}
                                &nbsp;&bull;&nbsp;
                                {translateISODateToString(item.publicationDate, {
                                    convertToMoscowDate: true,
                                })}
                            </Text>
                            <Block notPadded styler={{ marginTop: 12 }}>
                                <FontStyrene>
                                    <Text styler={{ margin: 0 }} view="xsmall">
                                        {item.title}
                                    </Text>
                                </FontStyrene>
                                <Text styler={{ margin: 0, marginTop: 8 }} view="primary-small">
                                    {item.description}
                                </Text>
                            </Block>
                            {image && (
                                <Img
                                    alt={`Лого ${image.name}`}
                                    className={cn(styles.external, styles.image)}
                                    height={300}
                                    src={image.link}
                                    styler={{ marginTop: 12 }}
                                    width={704}
                                />
                            )}
                        </Link>
                        {!!item.assets?.length && (
                            <AssetsCarousel
                                analytics={analytics}
                                assetCardTheme="grey"
                                assets={item.assets}
                                baseUrlToAsset={baseUrlToAsset}
                                className={cn(styles.external, styles.assetsLinksBlock)}
                            />
                        )}
                    </Block>
                );
            })}
        </div>
    );
};
